(() => {
  if (window.bpUgc) return

  const libraryNode = document.querySelector('[data-bp-ugc-library]')
  const i18nNode = document.querySelector('[data-bp-ugc-i18n]')
  if (!libraryNode || !i18nNode) return

  let items = []
  let text = {}
  try {
    items = JSON.parse(libraryNode.textContent)
    text = JSON.parse(i18nNode.textContent)
  } catch (error) {
    return
  }
  if (!items.length) return

  const decoder = document.createElement('textarea')
  const decodeEntities = (value) => {
    decoder.innerHTML = String(value || '')
    return decoder.value
  }
  Object.keys(text).forEach((key) => {
    text[key] = decodeEntities(text[key])
  })

  const IMAGE_DURATION = 5000
  const isImage = (item) => Boolean(item) && item.type === 'image'
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  const connection = navigator.connection || {}
  const lowData = Boolean(connection.saveData) || /2g$/.test(connection.effectiveType || '')

  let hasOpened = false
  let sectionViewed = false
  const track = (action, index) => {
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', `ugc_${action}`)
        if (action.indexOf('open_') === 0 && !hasOpened) window.clarity('set', 'ugc_opened', 'yes')
      }
    } catch (error) {}
    try {
      const analytics = window.Shopify && window.Shopify.analytics
      if (analytics && typeof analytics.publish === 'function') analytics.publish('bp_ugc', { action, index })
    } catch (error) {}
  }

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char])
  const counterText = (index) => String(text.counter || '[n] / [total]').replace('[n]', index + 1).replace('[total]', items.length)
  const svg = (path, size = 22) => `<svg viewBox="0 0 24 24" width="${size}" height="${size}" aria-hidden="true" focusable="false">${path}</svg>`
  const icons = {
    close: svg('<path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>'),
    soundOn: svg('<path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z" fill="currentColor"/><path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>'),
    soundOff: svg('<path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z" fill="currentColor"/><path d="M16 9.5l5 5M21 9.5l-5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>'),
    play: svg('<path d="M8 5.5v13l11-6.5z" fill="currentColor"/>', 30),
    pause: svg('<path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z" fill="currentColor"/>', 30),
    replay: svg('<path d="M5 12a7 7 0 1 0 2.05-4.95M5 4.5V9h4.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>', 30),
    prev: svg('<path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>'),
    next: svg('<path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>'),
  }

  const PLAYER_CSS = `
.bp-ugcp{position:fixed;inset:0;width:100vw;max-width:none;height:100vh;height:100dvh;max-height:none;margin:0;padding:0;border:0;background:#000;color:#fff;overflow:hidden;font-family:var(--text-font-family,system-ui,sans-serif)}
.bp-ugcp::backdrop{background:rgb(0 0 0 / .86)}
.bp-ugcp__sr{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}
.bp-ugcp__frame{position:relative;width:100%;height:100%;margin:0 auto;overflow:hidden;background:#000}
.bp-ugcp__scroller{display:flex;height:100%;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;overscroll-behavior:contain;scrollbar-width:none;-webkit-overflow-scrolling:touch}
.bp-ugcp__scroller::-webkit-scrollbar{display:none}
.bp-ugcp__slide{position:relative;flex:0 0 100%;width:100%;height:100%;overflow:hidden;scroll-snap-align:start;scroll-snap-stop:always;background:#000}
.bp-ugcp__poster,.bp-ugcp__video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}
.bp-ugcp__info{position:absolute;right:0;bottom:0;left:0;z-index:2;padding:80px 16px calc(env(safe-area-inset-bottom) + 84px);background:linear-gradient(to top,rgb(0 0 0 / .8),rgb(0 0 0 / 0));pointer-events:none}
.bp-ugcp__who{margin:0;font-size:15px;font-weight:700;line-height:1.3;overflow-wrap:anywhere}
.bp-ugcp__caption{display:-webkit-box;margin:4px 0 0;overflow:hidden;font-size:14px;line-height:1.35;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow-wrap:anywhere}
.bp-ugcp__progress{position:absolute;top:calc(env(safe-area-inset-top) + 8px);right:12px;left:12px;z-index:4;display:flex;gap:4px;pointer-events:none}
.bp-ugcp__segment{flex:1;height:3px;overflow:hidden;border-radius:2px;background:rgb(255 255 255 / .35)}
.bp-ugcp__segment span{display:block;height:100%;background:#fff;transform:scaleX(0);transform-origin:left center}
.bp-ugcp__segment.is-done span{transform:scaleX(1)}
.bp-ugcp__bar{position:absolute;top:calc(env(safe-area-inset-top) + 20px);right:10px;left:10px;z-index:4;display:flex;align-items:flex-start;justify-content:space-between;pointer-events:none}
.bp-ugcp__btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;min-width:44px;height:44px;padding:0 11px;border:0;border-radius:999px;background:rgb(0 0 0 / .45);color:#fff;font:inherit;font-size:14px;font-weight:700;line-height:1;cursor:pointer;pointer-events:auto;-webkit-tap-highlight-color:transparent}
.bp-ugcp__btn:focus-visible,.bp-ugcp__cta:focus-visible{outline:2px solid #fff;outline-offset:2px}
.bp-ugcp__sound-label{display:none}
.bp-ugcp__sound.is-prompt{padding-right:16px;background:#fff;color:#000}
.bp-ugcp__sound.is-prompt .bp-ugcp__sound-label{display:inline}
.bp-ugcp.is-image .bp-ugcp__sound{display:none}
.bp-ugcp.is-image [data-ugcp-close]{margin-left:auto}
.bp-ugcp__state{position:absolute;top:50%;left:50%;z-index:3;display:grid;place-items:center;width:72px;height:72px;border-radius:50%;background:rgb(0 0 0 / .5);opacity:0;transform:translate(-50%,-50%) scale(.9);transition:opacity .2s ease,transform .2s ease;pointer-events:none}
.bp-ugcp__state.is-visible{opacity:1;transform:translate(-50%,-50%) scale(1)}
.bp-ugcp__nav{display:none}
.bp-ugcp__footer{position:absolute;right:0;bottom:0;left:0;z-index:4;padding:0 16px calc(env(safe-area-inset-bottom) + 16px)}
.bp-ugcp__cta{display:flex;align-items:center;justify-content:center;width:100%;height:48px;padding:0 16px;border:0;border-radius:var(--rounded-button,999px);background:rgb(var(--button-background-primary,39 39 39));color:rgb(var(--button-text-primary,255 255 255));box-shadow:0 0 0 1px rgb(255 255 255 / .2);font:inherit;font-size:16px;font-weight:700;line-height:1.2;cursor:pointer;-webkit-tap-highlight-color:transparent}
.bp-ugcp.is-final .bp-ugcp__cta{animation:bp-ugcp-pulse 1.4s ease-in-out infinite}
@keyframes bp-ugcp-pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.035)}}
@media (min-width:768px){
.bp-ugcp{background:transparent}
.bp-ugcp[open]{display:grid;place-items:center}
.bp-ugcp__frame{width:auto;max-width:100vw;height:90vh;aspect-ratio:9/16;border-radius:12px}
.bp-ugcp__nav{position:absolute;top:50%;z-index:5;display:inline-flex;transform:translateY(-50%)}
.bp-ugcp__nav--prev{left:calc(50% - 45vh * 9 / 16 - 64px)}
.bp-ugcp__nav--next{left:calc(50% + 45vh * 9 / 16 + 20px)}
.bp-ugcp__nav:disabled{opacity:.35;cursor:default}
}
@media (prefers-reduced-motion:reduce){
.bp-ugcp__state{transition:none}
.bp-ugcp.is-final .bp-ugcp__cta{animation:none}
}`

  let dialog = null
  let scroller = null
  let slides = []
  let segments = []
  let liveRegion = null
  let soundButton = null
  let stateNode = null
  let ctaButton = null
  let prevButton = null
  let nextButton = null
  let video = null
  let nextVideo = null
  let currentIndex = -1
  let isOpen = false
  let opener = null
  let lockedScrollY = 0
  let previousRestoration = ''
  let afterClose = null
  let soundOn = true
  let progressFrame = 0
  let stateTimer = 0
  let imageElapsed = 0
  let imageStartedAt = 0
  let tapOrigin = null
  let tapMoved = false
  const startedIndexes = new Set()
  const previewStoppers = []

  const imageProgress = () => Math.min(1, (imageElapsed + (imageStartedAt ? performance.now() - imageStartedAt : 0)) / IMAGE_DURATION)
  const resumeImage = () => {
    if (!imageStartedAt) imageStartedAt = performance.now()
  }
  const pauseImage = () => {
    if (!imageStartedAt) return
    imageElapsed += performance.now() - imageStartedAt
    imageStartedAt = 0
  }
  const resetImage = () => {
    imageElapsed = 0
    imageStartedAt = 0
  }

  const markStarted = (index) => {
    if (startedIndexes.has(index)) return
    startedIndexes.add(index)
    track('play_start', index)
  }

  const setScrollBehavior = (value) => {
    const previous = document.documentElement.style.scrollBehavior
    document.documentElement.style.scrollBehavior = value
    return previous
  }

  const lockScroll = () => {
    lockedScrollY = window.scrollY
    const style = document.body.style
    style.position = 'fixed'
    style.top = `-${lockedScrollY}px`
    style.left = '0'
    style.right = '0'
    style.width = '100%'
    style.overflow = 'hidden'
  }

  const unlockScroll = () => {
    const style = document.body.style
    const lockedProperties = ['position', 'top', 'left', 'right', 'width', 'overflow']
    lockedProperties.forEach((property) => {
      style[property] = ''
    })
    const previous = setScrollBehavior('auto')
    window.scrollTo(0, lockedScrollY)
    setScrollBehavior(previous)
  }

  const renderSound = (prompt) => {
    soundButton.innerHTML = `${soundOn ? icons.soundOn : icons.soundOff}<span class="bp-ugcp__sound-label">${escapeHtml(text.sound_on)}</span>`
    soundButton.setAttribute('aria-label', soundOn ? text.sound_off : text.sound_on)
    soundButton.classList.toggle('is-prompt', Boolean(prompt) && !soundOn)
  }

  const showState = (kind, persistent) => {
    clearTimeout(stateTimer)
    stateNode.innerHTML = icons[kind]
    stateNode.classList.add('is-visible')
    if (!persistent) stateTimer = setTimeout(() => stateNode.classList.remove('is-visible'), 650)
  }

  const hideState = () => {
    clearTimeout(stateTimer)
    stateNode.classList.remove('is-visible')
  }

  const playCurrent = () => {
    const attempt = video.play()
    if (!attempt || typeof attempt.catch !== 'function') return
    attempt.catch((error) => {
      if (error && error.name === 'AbortError') return
      if (!video.muted) {
        soundOn = false
        video.muted = true
        renderSound(true)
        video.play().catch(() => showState('play', true))
        return
      }
      showState('play', true)
    })
  }

  const preloadNext = (index) => {
    const item = items[index]
    if (isImage(item)) {
      nextVideo.removeAttribute('src')
      new Image().src = item.src
      return
    }
    if (!item || lowData) {
      nextVideo.removeAttribute('src')
      return
    }
    if (nextVideo.getAttribute('src') !== item.src) nextVideo.src = item.src
  }

  const startImageWhenReady = (index) => {
    const image = slides[index].querySelector('.bp-ugcp__poster')
    const begin = () => {
      if (!isOpen || currentIndex !== index || imageElapsed || imageStartedAt) return
      resumeImage()
      markStarted(index)
    }
    if (!image || image.complete) {
      begin()
      return
    }
    image.loading = 'eager'
    image.addEventListener('load', begin, { once: true })
    image.addEventListener('error', begin, { once: true })
  }

  const updatePosition = () => {
    liveRegion.textContent = counterText(currentIndex)
    segments.forEach((segment, index) => {
      segment.classList.toggle('is-done', index < currentIndex)
      segment.firstElementChild.style.transform = index < currentIndex ? 'scaleX(1)' : 'scaleX(0)'
    })
    prevButton.disabled = currentIndex <= 0
    nextButton.disabled = currentIndex >= items.length - 1
  }

  const activate = (index) => {
    if (index < 0 || index >= items.length || index === currentIndex) return
    if (currentIndex !== -1) track('next', index)
    currentIndex = index
    const item = items[index]
    const slide = slides[index]
    dialog.classList.remove('is-final')
    hideState()
    resetImage()
    dialog.classList.toggle('is-image', isImage(item))
    if (isImage(item)) {
      video.pause()
      video.remove()
      video.removeAttribute('src')
      video.load()
      startImageWhenReady(index)
      preloadNext(index + 1)
      updatePosition()
      return
    }
    if (video.parentNode !== slide) slide.insertBefore(video, slide.querySelector('.bp-ugcp__info'))
    video.poster = item.poster || ''
    video.src = item.src
    video.muted = !soundOn
    playCurrent()
    preloadNext(index + 1)
    updatePosition()
  }

  const goTo = (index, instant) => {
    if (index < 0 || index >= items.length) return
    scroller.scrollTo({ left: slides[index].offsetLeft, behavior: instant || reducedMotion ? 'auto' : 'smooth' })
  }

  const step = (delta) => {
    const target = Math.min(items.length - 1, Math.max(0, currentIndex + delta))
    if (target !== currentIndex) goTo(target)
  }

  const handleEnded = () => {
    const index = currentIndex
    track('play_complete', index)
    if (index < items.length - 1) {
      goTo(index + 1)
      return
    }
    dialog.classList.add('is-final')
    showState('replay', true)
  }

  const runProgress = () => {
    const segment = segments[currentIndex]
    if (segment && isImage(items[currentIndex])) {
      const progress = imageProgress()
      segment.firstElementChild.style.transform = `scaleX(${progress})`
      if (progress >= 1 && imageStartedAt) {
        pauseImage()
        handleEnded()
      }
    } else if (segment && video.duration) {
      segment.firstElementChild.style.transform = `scaleX(${Math.min(1, video.currentTime / video.duration)})`
    }
    progressFrame = requestAnimationFrame(runProgress)
  }

  const closeNow = (options = {}) => {
    if (!isOpen) return
    isOpen = false
    cancelAnimationFrame(progressFrame)
    hideState()
    resetImage()
    dialog.classList.remove('is-image', 'is-final')
    video.pause()
    video.removeAttribute('src')
    video.load()
    nextVideo.removeAttribute('src')
    currentIndex = -1
    if (dialog.open) dialog.close()
    unlockScroll()
    const focusTarget = opener
    opener = null
    const then = afterClose
    afterClose = null
    if (focusTarget && !then && document.contains(focusTarget)) focusTarget.focus({ preventScroll: true })
    if (then) then()
    if (options.popHistory && history.state && history.state.bpUgcPlayer) history.back()
    setTimeout(() => {
      if (!isOpen && previousRestoration) history.scrollRestoration = previousRestoration
    }, 300)
  }

  const requestClose = (then) => {
    afterClose = then || null
    if (history.state && history.state.bpUgcPlayer) {
      history.back()
      return
    }
    closeNow()
  }

  const scrollToOffer = () => {
    const target = document.getElementById('achat') || document.querySelector('.bp-hero')
    if (!target) return
    const previous = setScrollBehavior('auto')
    target.scrollIntoView({ block: 'start' })
    setScrollBehavior(previous)
  }

  const focusables = () => [soundButton, dialog.querySelector('[data-ugcp-close]'), prevButton, nextButton, ctaButton]
    .filter((node) => node && !node.disabled && node.offsetParent !== null)

  const handleKeydown = (event) => {
    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
      event.preventDefault()
      step(1)
      return
    }
    if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      event.preventDefault()
      step(-1)
      return
    }
    if (event.key !== 'Tab') return
    const nodes = focusables()
    if (!nodes.length) return
    const first = nodes[0]
    const last = nodes[nodes.length - 1]
    if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }

  const replayCurrent = () => {
    dialog.classList.remove('is-final')
    hideState()
    if (isImage(items[currentIndex])) {
      resetImage()
      resumeImage()
      return
    }
    video.currentTime = 0
    playCurrent()
  }

  const handleSurfaceClick = (event) => {
    if (event.target.closest('button')) return
    if (tapMoved) return
    const frame = dialog.querySelector('.bp-ugcp__frame')
    const rect = frame.getBoundingClientRect()
    const goNext = event.clientX - rect.left >= rect.width * 0.28
    if (dialog.classList.contains('is-final')) {
      replayCurrent()
      return
    }
    if (goNext) {
      if (currentIndex < items.length - 1) step(1)
      else handleEnded()
      return
    }
    if (currentIndex > 0) {
      step(-1)
      return
    }
    replayCurrent()
  }

  const buildPlayer = () => {
    const style = document.createElement('style')
    style.textContent = PLAYER_CSS
    document.head.appendChild(style)

    dialog = document.createElement('dialog')
    dialog.className = 'bp-ugcp'
    dialog.setAttribute('aria-modal', 'true')
    dialog.setAttribute('aria-labelledby', 'bp-ugcp-title')
    const slideMarkup = items.map((item, index) => `
      <section class="bp-ugcp__slide" data-index="${index}" aria-label="${escapeHtml(counterText(index))}">
        ${item.poster ? `<img class="bp-ugcp__poster" src="${escapeHtml(item.poster)}" alt="" decoding="async" loading="lazy">` : ''}
        <div class="bp-ugcp__info">
          ${item.who ? `<p class="bp-ugcp__who">${escapeHtml(item.who)}</p>` : ''}
          ${item.caption ? `<p class="bp-ugcp__caption">${escapeHtml(item.caption)}</p>` : ''}
        </div>
      </section>`).join('')
    dialog.innerHTML = `
      <h2 class="bp-ugcp__sr" id="bp-ugcp-title">${escapeHtml(text.dialog_title)}</h2>
      <p class="bp-ugcp__sr" aria-live="polite" data-ugcp-live></p>
      <div class="bp-ugcp__frame">
        <div class="bp-ugcp__scroller" data-ugcp-scroller tabindex="-1">${slideMarkup}</div>
        <div class="bp-ugcp__progress" aria-hidden="true">${items.map(() => '<span class="bp-ugcp__segment"><span></span></span>').join('')}</div>
        <div class="bp-ugcp__bar">
          <button type="button" class="bp-ugcp__btn bp-ugcp__sound" data-ugcp-sound></button>
          <button type="button" class="bp-ugcp__btn" data-ugcp-close aria-label="${escapeHtml(text.close)}">${icons.close}</button>
        </div>
        <div class="bp-ugcp__state" data-ugcp-state aria-hidden="true"></div>
        <div class="bp-ugcp__footer">
          <button type="button" class="bp-ugcp__cta" data-ugcp-cta></button>
        </div>
      </div>
      <button type="button" class="bp-ugcp__btn bp-ugcp__nav bp-ugcp__nav--prev" data-ugcp-step="-1" aria-label="${escapeHtml(text.previous)}">${icons.prev}</button>
      <button type="button" class="bp-ugcp__btn bp-ugcp__nav bp-ugcp__nav--next" data-ugcp-step="1" aria-label="${escapeHtml(text.next)}">${icons.next}</button>`
    document.body.appendChild(dialog)

    scroller = dialog.querySelector('[data-ugcp-scroller]')
    slides = Array.from(dialog.querySelectorAll('.bp-ugcp__slide'))
    segments = Array.from(dialog.querySelectorAll('.bp-ugcp__segment'))
    liveRegion = dialog.querySelector('[data-ugcp-live]')
    soundButton = dialog.querySelector('[data-ugcp-sound]')
    stateNode = dialog.querySelector('[data-ugcp-state]')
    ctaButton = dialog.querySelector('[data-ugcp-cta]')
    prevButton = dialog.querySelector('.bp-ugcp__nav--prev')
    nextButton = dialog.querySelector('.bp-ugcp__nav--next')

    video = document.createElement('video')
    video.className = 'bp-ugcp__video'
    video.playsInline = true
    video.setAttribute('playsinline', '')
    video.setAttribute('webkit-playsinline', '')
    video.preload = 'auto'
    video.disablePictureInPicture = true
    nextVideo = document.createElement('video')
    nextVideo.muted = true
    nextVideo.playsInline = true
    nextVideo.preload = 'metadata'

    video.addEventListener('playing', () => {
      hideState()
      markStarted(currentIndex)
    })
    video.addEventListener('ended', handleEnded)

    const slideObserver = new IntersectionObserver((entries) => {
      if (!isOpen) return
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) activate(Number(entry.target.dataset.index))
      })
    }, { root: scroller, threshold: [0.6] })
    slides.forEach((slide) => slideObserver.observe(slide))

    scroller.addEventListener('pointerdown', (event) => {
      tapOrigin = { x: event.clientX, y: event.clientY }
      tapMoved = false
    })
    scroller.addEventListener('pointermove', (event) => {
      if (!tapOrigin) return
      if (Math.abs(event.clientX - tapOrigin.x) > 10 || Math.abs(event.clientY - tapOrigin.y) > 10) tapMoved = true
    })
    scroller.addEventListener('pointerup', () => {
      tapOrigin = null
    })
    scroller.addEventListener('click', handleSurfaceClick)
    soundButton.addEventListener('click', () => {
      soundOn = !soundOn
      video.muted = !soundOn
      renderSound(false)
      if (soundOn && video.paused) playCurrent()
    })
    dialog.querySelector('[data-ugcp-close]').addEventListener('click', () => requestClose())
    prevButton.addEventListener('click', () => step(-1))
    nextButton.addEventListener('click', () => step(1))
    ctaButton.addEventListener('click', () => {
      track('cta_click', currentIndex)
      requestClose(scrollToOffer)
    })
    dialog.addEventListener('keydown', handleKeydown)
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault()
      requestClose()
    })
    dialog.addEventListener('close', () => closeNow({ popHistory: true }))
    window.addEventListener('popstate', () => closeNow())
  }

  const open = (index, source, trigger) => {
    if (isOpen) return
    if (!dialog) buildPlayer()
    previewStoppers.forEach((stop) => stop())
    const start = Math.min(items.length - 1, Math.max(0, index || 0))
    const root = trigger && trigger.closest('[data-bp-ugc-root]')
    isOpen = true
    opener = trigger || null
    ctaButton.textContent = (root && root.dataset.cta) || text.cta
    track(source === 'section' || source === 'pill' ? `open_${source}` : 'open_strip', start)
    hasOpened = true
    soundOn = true
    renderSound(false)
    previousRestoration = history.scrollRestoration
    history.scrollRestoration = 'manual'
    history.pushState(Object.assign({}, history.state, { bpUgcPlayer: true }), '')
    lockScroll()
    dialog.showModal()
    scroller.scrollLeft = slides[start].offsetLeft
    currentIndex = -1
    activate(start)
    cancelAnimationFrame(progressFrame)
    progressFrame = requestAnimationFrame(runProgress)
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-bp-ugc-open]')
    if (!trigger) return
    event.preventDefault()
    open(Number(trigger.dataset.bpUgcOpen), trigger.dataset.bpUgcSource, trigger)
  })

  const initPreview = (cards) => {
    const ratios = new Map()
    let timer = 0
    let current = null
    const stop = () => {
      clearTimeout(timer)
      if (!current) return
      const preview = current.querySelector('.bp-ugcr__preview')
      if (preview) {
        preview.pause()
        preview.remove()
      }
      current.classList.remove('is-previewing')
      current = null
    }
    const start = (button) => {
      if (current === button || isOpen) return
      stop()
      const item = items[Number(button.dataset.bpUgcOpen)]
      if (!item || isImage(item)) return
      const preview = document.createElement('video')
      preview.className = 'bp-ugcr__preview'
      preview.muted = true
      preview.loop = true
      preview.playsInline = true
      preview.setAttribute('playsinline', '')
      preview.setAttribute('aria-hidden', 'true')
      preview.preload = 'auto'
      preview.src = item.src
      const poster = button.querySelector('.bp-ugcr__poster')
      button.insertBefore(preview, poster ? poster.nextSibling : button.firstChild)
      preview.play().catch(() => {})
      button.classList.add('is-previewing')
      current = button
    }
    previewStoppers.push(stop)
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => ratios.set(entry.target, entry.intersectionRatio))
      clearTimeout(timer)
      let best = null
      let bestRatio = 0
      ratios.forEach((ratio, node) => {
        if (ratio > bestRatio) {
          best = node
          bestRatio = ratio
        }
      })
      if (!best || bestRatio < 0.6) {
        stop()
        return
      }
      timer = setTimeout(() => start(best), 600)
    }, { threshold: [0, 0.3, 0.6, 0.8, 1] })
    cards.forEach((card) => observer.observe(card))
  }

  const initReels = (root) => {
    if (root.dataset.ready) return
    root.dataset.ready = 'true'
    const trackNode = root.querySelector('[data-bp-ugc-track]')
    if (!trackNode) return
    const cards = Array.from(trackNode.querySelectorAll('[data-bp-ugc-open]'))
    const items_ = Array.from(trackNode.children)
    const dots = Array.from(root.querySelectorAll('.bp-ugcr__dot'))
    const arrows = Array.from(root.querySelectorAll('[data-bp-ugc-scroll]'))
    let frame = 0

    const activeIndex = () => {
      if (trackNode.scrollLeft + trackNode.clientWidth >= trackNode.scrollWidth - 2) return items_.length - 1
      const origin = trackNode.getBoundingClientRect().left + 16
      let best = 0
      let bestDistance = Infinity
      items_.forEach((item, index) => {
        const distance = Math.abs(item.getBoundingClientRect().left - origin)
        if (distance < bestDistance) {
          best = index
          bestDistance = distance
        }
      })
      return best
    }
    const update = () => {
      frame = 0
      const scrollable = trackNode.scrollWidth > trackNode.clientWidth + 2
      root.classList.toggle('is-static', !scrollable)
      const active = scrollable ? activeIndex() : 0
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active))
      arrows.forEach((arrow) => {
        const direction = Number(arrow.dataset.bpUgcScroll)
        arrow.disabled = direction < 0 ? trackNode.scrollLeft <= 2 : trackNode.scrollLeft + trackNode.clientWidth >= trackNode.scrollWidth - 2
      })
    }
    const scheduleUpdate = () => {
      if (!frame) frame = requestAnimationFrame(update)
    }
    trackNode.addEventListener('scroll', scheduleUpdate, { passive: true })
    window.addEventListener('resize', scheduleUpdate, { passive: true })
    arrows.forEach((arrow) => arrow.addEventListener('click', () => {
      const first = items_[0]
      const stride = first ? first.getBoundingClientRect().width + 12 : trackNode.clientWidth
      const perPage = Math.max(1, Math.floor((trackNode.clientWidth + 12) / stride))
      trackNode.scrollBy({ left: Number(arrow.dataset.bpUgcScroll) * stride * perPage, behavior: reducedMotion ? 'auto' : 'smooth' })
    }))
    update()

    if ('IntersectionObserver' in window) {
      const viewObserver = new IntersectionObserver((entries) => {
        if (sectionViewed || !entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5)) return
        sectionViewed = true
        viewObserver.disconnect()
        track('section_view', null)
      }, { threshold: [0.5] })
      viewObserver.observe(root)
      if (root.dataset.preview === 'true' && !reducedMotion && !lowData) initPreview(cards)
    }
  }

  document.querySelectorAll('[data-bp-ugc-reels]').forEach(initReels)
  window.bpUgc = { open, items }
})()
